import { Component, OnInit, inject } from '@angular/core';
import { ActionsService, ErrorService, UserService } from '@app/core/services';

@Component({
  selector: 'howden-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {
  private errSrv = inject(ErrorService);
  private userSrv = inject(UserService);
  private actionsSrv = inject(ActionsService);

  msg: string | undefined;
  showGoHome = false;

  ngOnInit(): void {
    this.msg = this.errSrv.errorMsg;
    this.showGoHome = !this.userSrv.validCallBack;
    this.actionsSrv.hideLoading();
  }

  goHome() {
    window.location.href = this.userSrv.callBackStr;
  }
}
